import React from 'react';
import DisposalDialog from './DisposalDialog';
import {ItemDeletionImpact} from '../../service/DisposalApi';
import {plural} from '../../utils/plural';

/**
 * Удаление ошибочно заведённой записи — не выбытие. Вещи не было, значит не должно остаться
 * ни её фотографий, ни истории носки, ни комментариев, и в статистике выбытия ей не место.
 * Поэтому диалог перечисляет состав записи: по нему видно, не путает ли человек ошибку учёта
 * с расставанием с настоящей вещью.
 */
export default function DeleteRecordDialog({name, impact, onConfirm, onCancel}: {
    name: string;
    /** null — состав ещё грузится или запрос не удался: диалог честно говорит, что не знает. */
    impact: ItemDeletionImpact | null;
    onConfirm: () => void;
    onCancel: () => void;
}) {
    return (
        <DisposalDialog
            title="Удалить запись о вещи?"
            tone="danger"
            confirmLabel="Удалить запись"
            onConfirm={onConfirm}
            onCancel={onCancel}
        >
            <p>«{name}» исчезнет из гардероба вместе со всем, что к ней привязано.</p>
            {impact ? (
                <ul className="list-disc pl-5" data-testid="delete-record-impact">
                    <li>{plural(impact.photoCount, 'фотография', 'фотографии', 'фотографий')}</li>
                    <li>{plural(impact.wearCount, 'запись носки', 'записи носки', 'записей носки')}</li>
                    <li>{plural(impact.commentCount, 'комментарий', 'комментария', 'комментариев')}</li>
                </ul>
            ) : (
                <p className="text-gray-500 dark:text-gray-400" data-testid="delete-record-impact-unknown">
                    Состав записи подсчитать не удалось — удаление всё равно необратимо.
                </p>
            )}
            <p className="text-gray-500 dark:text-gray-400">
                Это удаление ошибки учёта, а не выбытие: в статистику выбытия запись не попадёт.
                Если вещь существует и вы с ней расстались — вернитесь и отметьте способ.
            </p>
        </DisposalDialog>
    );
}
